/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {PersonAutocompleteVoModel} from './person-autocomplete-vo.model';

@Injectable({
  providedIn: 'root'
})
export class PersonAutocompleteResourceService extends AbstractResourceService<PersonAutocompleteVoModel,
  PersonAutocompleteVoModel,
  undefined,
  undefined> {
  constructor(protected httpClient: HttpClient,
              private environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('companyPersonUrl'),
      PersonAutocompleteVoModel,
      PersonAutocompleteVoModel,
      undefined,
      undefined
    );
  }
}
